import { render, staticRenderFns } from "./MyPageView.vue?vue&type=template&id=5b31e1ec&scoped=true&"
import script from "./MyPageView.vue?vue&type=script&lang=js&"
export * from "./MyPageView.vue?vue&type=script&lang=js&"
import style0 from "./MyPageView.vue?vue&type=style&index=0&id=5b31e1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31e1ec",
  null
  
)

export default component.exports